import React, { useState } from "react";
import { message, Modal } from "antd";
import { ReactMultiEmail } from "react-multi-email";
import "react-multi-email/dist/style.css";
import Button from "../../../common/Button";
import { useDownloadInput, useDownloadOutput } from "../../../hooks/useAdmin";
import useAuthContext from "../../../hooks/useAuthContext";
import "../AdminBatchList/style.scss";

const AdminDownloadInputModal = ({ onClose, batchId, skuNames, kind = "input" }) => {
  const isOutput = kind === "output";
  const {
    user: { userEmail },
  } = useAuthContext();
  const [emails, setEmails] = useState(userEmail ? [userEmail] : []);
  const onSuccess = () => {
    message.success("Download requested. A zip link will be emailed shortly.");
    onClose();
  };
  const onError = (err) =>
    message.error(err?.response?.data?.message || "Download failed, please try again.");
  const { mutate: downloadInput, isLoading: inputLoading } = useDownloadInput(
    onSuccess,
    onError
  );
  const { mutate: downloadOutput, isLoading: outputLoading } = useDownloadOutput(
    onSuccess,
    onError
  );
  const isLoading = isOutput ? outputLoading : inputLoading;
  const title = isOutput
    ? "Download batch output"
    : skuNames?.length
      ? "Download SKU input"
      : "Download batch input";

  return (
    <Modal
      title={title}
      open
      onCancel={onClose}
      className="download_modal_wrapper"
      footer={null}
      width="70%"
    >
      <div className="download_modal_container">
        <p className="download_hint">
          {isOutput
            ? "We will zip completed deliverable images and email the download link."
            : "We will zip the original input images and email the download link."}
        </p>
        <div className="download_form_wrapper">
          <ReactMultiEmail
            placeholder="Enter email addresses"
            emails={emails}
            onChange={setEmails}
            getLabel={(email, index, removeEmail) => (
              <div data-tag key={index}>
                {email}
                <span data-tag-handle onClick={() => removeEmail(index)}>
                  ×
                </span>
              </div>
            )}
          />
        </div>
        <div className="action_wrapper">
          <button className="cancelBtn" onClick={onClose}>
            Cancel
          </button>
          <Button
            width="140px"
            height="50px"
            text={isLoading ? "Sending..." : "Send zip"}
            isDisabled={isLoading}
            handleClick={() => {
              if (!emails?.length) {
                message.error("Please add at least one email.");
                return;
              }
              if (isOutput) {
                downloadOutput({ batchId, toEmailIds: emails });
                return;
              }
              downloadInput({
                batchId,
                toEmailIds: emails,
                ...(skuNames?.length ? { skuNames } : {}),
              });
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default AdminDownloadInputModal;
